<template>
  <Dialog v-on="$listeners" v-bind="$attrs" :title="locale.eventRules">
    <div class="ff--common">
      <!-- 1 -->
      <div data-level="1">1. Event Time</div>
      <div data-level="2">
        This event will start on 2023/07/21 at 00:00 UTC+0 and end on 2023/08/21
        at 00:00 UTC+0.
      </div>
      <!-- 2 -->
      <div data-level="1">2. Event Details</div>
      <!-- 2-1 -->
      <div data-level="2">2.1 Participating in the Event</div>
      <div data-level="3">
        i. Eligibility: This event is only open to Rise of Kingdoms (hereinafter
        referred to as "the game" or "RoK") players in certain countries or
        regions (please refer to the "List of Countries/Regions for This Event"
        at the end of this announcement). This event is open to players who
        register both before and after the event starts (hereinafter referred to
        as "you").
      </div>
      <div data-level="3">ii. Participation Method:</div>
      <div data-level="4">
        1. Choose the civilization you wish to support, tap “Join,” and submit
        your email address and UID on the event page. Your participation will be
        deemed valid after completing verification with the verification code
        sent to your in-game mailbox.
      </div>
      <div data-level="4">
        2. After choosing your civilization, you will receive a free
        scratchcard. Scratch the card for a chance to win a prize. You can win
        additional scratchcards by completing event quests.
      </div>
      <div data-level="4">
        3. After making your choice, your ID will be included in the list of
        supporters of your chosen civilization and your in-game power will be
        recorded. When the event ends, you will be ranked among all
        participating players by how much power you have increased. If the
        civilization you support ranks in the top three in terms of total power
        increase, you will be eligible to draw a prize from the Civilization
        Pool and stand a chance to win a Civilization Pool Grand Prize. In
        addition, we will give additional rewards to the players with the
        highest individual power increase in each of the top three
        civilizations.
      </div>
      <!-- 2-2 -->
      <div data-level="2">2.2 Prize Rules</div>
      <div data-level="3">i. Civilization Pool Grand Prizes:</div>
      <div data-level="4">
        1. To calculate a civilization’s total power increase, we will add up
        the power increase of all participating players who are supporting that
        civilization. For example, the total power increase of Egypt will be the
        sum of the power increase of all participating players who chose to
        support Egypt.
      </div>
      <div data-level="4">
        2. All supporters of the top three civilizations will get to draw a
        prize.
      </div>
      <div data-level="5">
        One randomly-chosen supporter of the 1st place civilization will win an
        <a
          target="_blank"
          href="https://www.apple.com/apple-vision-pro/AppleVisionPro"
          >Apple Vision Pro</a
        >.
      </div>
      <div data-level="5">
        One randomly-chosen supporter of the 2nd place civilization will win a
        Sony PlayStation 5.
      </div>
      <div data-level="5">
        One randomly-chosen supporter of the 3rd place civilization will win a
        Nintendo Switch OLED.
      </div>
      <div data-level="4">
        3. The Grand Prize winners will be chosen at random. Players
        participating in this event will abide by the official prize draw rules
        and accept the subsequent draw results. If you have any questions,
        please submit your feedback during the announcement phase.
      </div>
      <div data-level="3">ii. Individual Rewards:</div>
      <div data-level="4">
        1. The supporters of the top three civilizations with the highest
        individual power increases will win additional rewards.
      </div>
      <div data-level="5">
        The player with the highest power increase in the 1st place civilization
        will win an Apple Vision Pro.
      </div>
      <div data-level="5">
        The player with the highest power increase in the 2nd place civilization
        will win a Sony PlayStation 5.
      </div>
      <div data-level="5">
        The player with the highest power increase in the 3rd place civilization
        will win a Nintendo Switch OLED.
      </div>
      <div data-level="4">
        2. Your individual power will be based on the account tied to the UID
        you used to sign up for the event.
      </div>
      <div data-level="3">iii. Scratchcard Rewards:</div>
      <div data-level="4">
        1. You can earn scratchcards by selecting a civilization to support and
        by completing event quests.
      </div>
      <div data-level="4">
        2. You can scratch up to 5 cards per day. Once you’ve scratched 30
        cards, you are guaranteed to win an Amazon gift card. After your 30th
        scratchcard, you will not receive another guaranteed Amazon gift card if
        scratch another 30 cards, but you will have a 1% chance to win another
        gift card with every subsequent scratchcard.
      </div>
      <div data-level="3">
        iv. Participation Rewards: Enter the gift code in-game to get 20 Silver
        Keys.
      </div>
      <div data-level="3">
        *Rankings will be updated at 04:00 UTC+0 on the following day.
      </div>
      <div data-level="3">
        *Winners will be displayed on the event page for 10 business days. If
        you have any questions regarding the event, please reach out to us
        during the announcement phase at
        <a href="mailto:overseas.marketing@lilith.com"
          >overseas.marketing@lilith.com</a
        >. After the announcement phase ends, we will stop receiving player
        feedback.
      </div>
      <div data-level="2">2.3 How to Collect Prizes</div>
      <div data-level="3">i. Physical Prizes:</div>
      <div data-level="4">
        1. If you win a physical prize, we will contact you via in-game mail.
        The account we send the message to will be the account you used to sign
        up for the event. You must submit your shipping address and other
        required information within 7 days of receiving our message. If you fail
        to do so, your prize will be forfeit.
      </div>
      <div data-level="4">
        2. After your information has been confirmed, we will ship your prize to
        you. The shipping method and logistics provider used will depend on your
        shipping address. The delivery time may vary depending on your location
        and other circumstances.
      </div>
      <div data-level="4">
        3. Note: For the winner of the Apple Vision Pro, we will ship the prize
        to you within six months after the product is released in your country
        or region. The specific release time and availability in different
        regions are subject to Apple. If the prize cannot be shipped to your
        country or region, we will contact you again.
      </div>
      <div data-level="3">ii. Virtual Prizes</div>
      <div data-level="4">
        1. Amazon Gift Cards: We will send you a redemption code via in-game
        mail. The account we send the message to will be the account you used to
        sign up for the event. To redeem your gift card, visit the Amazon
        website.
      </div>
      <div data-level="4">
        2. Bundles: Enter the gift code provided to you in-game.
      </div>
      <!-- 3 -->
      <div data-level="1">3. Important Notes</div>
      <div data-level="2">
        a. We will utilize third-party services to verify the validity of
        participating users. Therefore, please refrain from cheating by using
        multiple devices. Doing so may result in disqualification from the
        event.
      </div>
      <div data-level="2">
        b. If you are an iOS user, you will receive a pop-up asking for
        permission to track your activity. Tracking is required for us to
        identify you as a participant.
      </div>
      <!-- 4 -->
      <div data-level="1">
        4. By participating in this event, you agree to accept all the terms and
        conditions of the event.
      </div>
      <div data-level="2">
        a. We have no direct relationship with Apple, Sony, Nintendo, Amazon,
        etc., and this event is in no way sponsored by any of the aforementioned
        brands.
      </div>
      <div data-level="2">
        b. Any fraudulent activity, such as using multiple devices to
        artificially increase activity, will result in disqualification from the
        event.
      </div>
      <div data-level="2">
        c. The personal information you provide in this event, including but not
        limited to your UID, email address, real name, shipping information, and
        residential address, will be used for the management of this event and
        to verify any prizes you win. Please note that if you win a physical
        prize, we may need to provide some information to the logistics company
        to verify your identity and ensure proper delivery. We will only share
        information that is necessary for shipping with the logistics companies
        and require them to handle your information in accordance with our
        privacy policy and applicable laws. We fully understand the importance
        of protecting user privacy. We are committed to handling your personal
        information in a responsible and transparent manner. If you have any
        questions about our privacy practices or use of information, please
        contact us at any time.
      </div>
      <div data-level="2">
        d. We reserve the right to modify or cancel the event at any time.
      </div>
      <div data-level="2">
        e. By participating in this event, you agree to release us from any and
        all liability related to the event.
      </div>
      <div data-level="2">
        f. We reserve the right to final explanation of this event.
      </div>
      <div data-level="1">5. Appendix</div>
      <div data-level="2">
        *List of Countries/Regions for This Event (ln No Particular Order)
      </div>
      <pre data-level="2" class="ff--common" style="white-space: pre-wrap">
  Australia
  Papua New Guinea
  Pakistan
  Bhutan
  Philippines
  Fiji
  Kazakhstan
  Kyrgyzstan
  Cambodia
  Laos
  Maldives
  Malaysia
  Mongolia
  Federated States of Micronesia
  Myanmar
  Nauru
  Nepal
  Palau
  Sri Lanka
  Solomon Islands
  Tajikistan
  Thailand
  Tonga
  Turkmenistan
  Vanuatu
  Brunei
  Uzbekistan
  Singapore
  New Zealand
  Indonesia
  Canada
  United States
  Albania
  Ireland
  Estonia
  Austria
  Belarus
  Bulgaria
  North Macedonia
  Belgium
  Iceland
  Poland
  Bosnia and Herzegovina
  Denmark
  Germany
  Russia
  France
  Finland
  Netherlands
  Montenegro
  Czech Republic
  Kosovo
  Croatia
  Latvia
  Lithuania
  Luxembourg
  Romania
  Malta
  Moldova
  Norway
  Portugal
  Sweden
  Switzerland
  Serbia
  Cyprus
  Slovakia
  Slovenia
  Türkiye
  Ukraine
  Spain
  Greece
  Hungary
  Italy
  United Kingdom
  Algeria
  Afghanistan
  United Arab Emirates
  Oman
  Azerbaijan
  Egypt
  Angola
  Bahrain
  Benin
  Botswana
  Burkina Faso
  Cabo Verde
  The Gambia
  Republic of the Congo
  Democratic Republic of the Congo
  Georgia
  Guinea-Bissau
  Ghana
  Gabon
  Zimbabwe
  Cameroon
  Qatar
  Côte d'Ivoire
  Kuwait
  Kenya
  Lebanon
  Liberia
  Libya
  Rwanda
  Madagascar
  Malawi
  Mali
  Mauritius
  Mauritania
  Morocco
  Mozambique
  Namibia
  South Africa
  Niger
  Nigeria
  Sierra Leone
  Senegal
  Seychelles
  Saudi Arabia
  São Tomé and Príncipe
  Eswatini
  Tanzania
  Tunisia
  Uganda
  Armenia
  Yemen
  Iraq
  Israel
  India
  Jordan
  Zambia
  Chad
  Argentina
  Anguilla
  Antigua and Barbuda
  Barbados
  The Bahamas
  Paraguay
  Panama
  Brazil
  Bermuda
  Bolivia
  Belize
  Dominican Republic
  Dominica
  Ecuador
  Colombia
  Costa Rica
  Grenada
  Guyana
  Honduras
  Cayman Islands
  Montserrat
  Peru
  Mexico
  Nicaragua
  EI Salvador
  Saint Kitts and Nevis
  Saint Lucia
  Saint Vincent and the Grenadines
  Suriname
  Turks and Caicos Islands
  Trinidad and Tobago
  Guatemala
  Venezuela
  Uruguay
  Jamaica
  British Virgin Islands
  Chile
      </pre>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "./dlg.vue";

export default {
  name: "RuleDialog",
  components: {
    Dialog,
  },
  data() {
    return {
      locale: this.$locale.dialog.rules,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
::v-deep {
  .dialog-body {
    padding: 40px;
    max-height: 60vh;
    overflow: hidden auto;
  }
}

em {
  font-style: normal;
  font-weight: 500;
}

@padding-left: 30px;

[data-level] {
  margin-bottom: 10px;
  line-height: 30px;

  a {
    color: #fff08e;
    text-decoration: underline;
  }
}

[data-level="1"] {
  font-size: 24px;
  color: #fff08e;
}

[data-level="2"] {
  font-size: 20px;
  color: #fefde5;
  padding-left: @padding-left;
}

[data-level="3"] {
  font-size: 22px;
  color: #fefde5;
  padding-left: @padding-left * 2;
}

[data-level="4"] {
  font-size: 20px;
  color: #fefde5;
  padding-left: @padding-left * 3;
}

[data-level="5"] {
  font-size: 18px;
  color: #fefde5;
  padding-left: @padding-left * 4;
}
</style>
